// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"0a29e030","477":"6ed7ee2b","616":"22a1d75b","809":"a2e94bbc"}[chunkId] + ".chunk.js";
};